// src/services/api/accountApi.ts
import axios from 'axios';
import { getBaseUrl, API_CONFIG } from '@/config/api';
import { AccountPerformance } from '@/types/AccountPerformance';
import { AccountDetail } from '@/types/AccountDetail';

// Endpoint: GET /accounts/performance
export const fetchAccountPerformance = async (): Promise<AccountPerformance> => {
  const url = `${getBaseUrl()}${API_CONFIG.ENDPOINTS.ACCOUNTS.LIST}/performance`;

  const response = await axios.get<AccountPerformance>(url, {
    withCredentials: true,
    timeout: API_CONFIG.TIMEOUT,
    headers: API_CONFIG.HEADERS,
  });

  return response.data;
};

// Endpoint: GET /accounts/{accountId}/details
export const fetchAccountDetail = async (accountId: number): Promise<AccountDetail> => {
  const url = `${getBaseUrl()}/accounts/${accountId}/details`;

  const response = await axios.get<AccountDetail>(url, {
    withCredentials: true,
    timeout: API_CONFIG.TIMEOUT,
    headers: API_CONFIG.HEADERS,
  });

  return response.data;
};
